angular
  .module("statistiche.components", [])
  .component("statistiche", {
    templateUrl: "ng/components/statistiche/statistiche.view.html",
    bindings: {},
    controllerAs: "statisticheCtrl",
    controller: function statistiche(
      $typeDomainService,
      $location
    ) {

      var self = this;
      self.$onInit = function () {
        self.showFrames = false;
        self.reportMode = {
          value: null
        }
        self.checkInternetProtocol = $location.$$protocol == 'http' ? true : false;
        getReports();
      }

      // self.checkReportMode = function(value){
      //   switch(value){
      //     case "link":
      //       self.reportMode.value = value;
      //       self.showLinks = true;
      //       self.dropDown = false;
      //       if(!self.elencoReport){
      //         getReports();
      //       }
      //       break; 
      //     case "iframes":
      //       self.showLinks = false;
      //       self.dropDown = true;
      //       self.reportMode.value = value;
      //       if(!self.elencoReport){

      //       }
      //       break;
      //     case "jsapi":
      //       self.reportMode.value = value;
      //       console.log("JAVASCRIPT API - Ancora da implementare");
      //     break;
      //   }
      // }

      self.getSelectedContract = function (value) {
        self.showFrames = true;
        self.currentUrl = value.value;
        self.checkInternetProtocol = $location.$$protocol == 'https' ? true : false;
      }

      var getReports = function () {
        self.restIsPending = true;
        $typeDomainService.getReports(self.checkInternetProtocol)
          .then(function (response) {
            self.restIsPending = false;
            self.elencoReport = response.domainList;
          })
          .catch(function (error) {
            console.log("error: ", error);
          });
      }
    }
  });